import types from './types';

/* Change date */
export const changeDate = (date) => ({
    type: types.CHANGE_DATE,
    payload: date
});

/* Change date range */
export const changeDateRange = (dateRange) => ({
    type: types.CHANGE_DATE_RANGE,
    payload: dateRange
});

/* Change render type */
export const changeRenderType = (renderType) => ({
    type: types.CHANGE_RENDER_TYPE,
    payload: renderType
});

/* Change user info */
export const changeUserInfo = (userInfo) => ({
    type: types.CHANGE_USER_INFO,
    payload: userInfo
});

/* Change portfolios data */
export const changePortfoliosData = (portfoliosData) => ({
    type: types.CHANGE_PORTFOLIOS_DATA,
    payload: portfoliosData
});

/* Change chosen portfolio data */
export const changeChosenPortfolioData = (chosenPortfolioData) => ({
    type: types.CHANGE_CHOSEN_PORTFOLIO_DATA,
    payload: chosenPortfolioData
});

/* Change trading chart data */
export const changeTradingChartData = (tradingChartData) => ({
    type: types.CHANGE_TRADING_CHART_DATA,
    payload: tradingChartData
});

/* Change trading report data */
export const changeTradingReportData = (tradingReportData) => ({
    type: types.CHANGE_TRADING_REPORT_DATA,
    payload: tradingReportData
});

/* Toggle modal for signal table */
export const toggleSignalTableDialog = (openModal)=>({
    type: types.TOGGLE_SIGNAL_TABLE_DIALOG,
    payload: openModal
});

/* Force upload disable button for signal table */
export const forceUploadDisableButton = (forceDisableBtn)=>({
    type: types.FORCE_UPLOAD_DISABLE_BUTTON,
    payload: forceDisableBtn
});

/* Change status info */
export const changeStatusInfo = (statusInfo)=>({
    type: types.CHANGE_STATUS_INFO,
    payload: statusInfo
});

/* Change organization users */
export const changeOrganizationUsers = (users)=>({
    type: types.CHANGE_ORGANIZATION_USERS,
    payload: users
});

/* Change organization documents */
export const changeOrganizationDocuments = (documents)=>({
    type: types.CHANGE_ORGANIZATION_DOCUMENTS,
    payload: documents
});

/* Toggle remaining days before pass expire error */
export const changePasswordExpirationError = (bool)=>({
  type:types.TOGGLE_EXPIRATION_ERROR,
  payload:bool
})
